import React, { useContext } from "react";
import { CombinedContext } from "../../context/combinedContext";
import AdminCalendar from "./adminCalendar/adminCalendar";
import StaffCalendar from "./staffCalendar/staffCalendar";

import "./calendarCards.css"
const CalendarCard = () => {
	const { userData } = useContext(CombinedContext);
	const role = userData?.user?.role;

	if (!role) return null;
	

	if (role === "admin" || role === "owner") return <AdminCalendar/>;
	return <StaffCalendar />;
};

export default CalendarCard;